import { Card, Col , Row, Container} from 'react-bootstrap';
import { Link, Redirect } from "react-router-dom";
import React, { useEffect } from 'react'
import { videos } from '../../data/videos';
import AuthService from "../../services/auth.service";
import { Login } from "./Login"

export const OnDemand = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    
    const user = AuthService.getCurrentUser();
    
    if ( !user ) {
        return <Redirect to={{
            pathname: '/login',
            state: { page: '/on-demand' }
        }} />;
    }

    return (
        <>
            {
                    user ? (
                    <>
                        <Container >
                            <Row>
                                {
                                    videos.map(item => (
                                        <Col sm key={item.id} className="card-columns animate__animated animate__fadeIn">          
                                            <Card style={{ width: '18rem' }}>  
                                                <Link to={ `./on-demand/${ item.id }` }>
                                                    <a href={ `./on-demand/${ item.id }` } target="_blank" rel="noopener noreferrer">
                                                        <Card.Img  variant="top" src={ item.image } />
                                                    </a> 
                                                </Link>
                                                <Card.Body>
                                                    <Card.Text style={{textAlign: "center"}}>
                                                        { item.title }
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </Container>
                    </>
                    ) : (
                    <>
                        <Login />

                        <Container >
                            <Row>
                                {
                                    videos.map(item => (
                                        <Col sm key={item.id} className="card-columns animate__animated animate__fadeIn">          
                                            <Card style={{ width: '18rem' }}>  
                                                <Link to={ `./on-demand/${ item.id }` }>
                                                    <a href={ `./on-demand/${ item.id }` } target="_blank" rel="noopener noreferrer">
                                                        <Card.Img  variant="top" src={ item.image } />
                                                    </a> 
                                                </Link>
                                                <Card.Body>
                                                    <Card.Text style={{textAlign: "center"}}>
                                                        { item.title }
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </Container>
                    </>
                    )
            }
        
        </>
    )
}